<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     [attr.transform]="rotation"
     preserveAspectRatio="xMidYMid meet">
    <rect x="0"
          y="0"
          ry="115"
          rx="115"
          [attr.width]="viewBoxWidth()"
          [attr.height]="getViewBoxHeight()"
          fill="blue"
          class="base"/>
    @for (line of board; track $index; let y = $index) {
        <g>
            @for (content of line; track $index; let x = $index) {
                <g>
                    <g id="click-{{ x }}-{{ y }}"
                       app-numbered-circle
                       [attr.transform]="getPieceTransform(x, y)"
                       (click)="onClick(x, y)"
                       [x]="x"
                       [y]="y"
                       [content]="content"
                       [spaceClasses]="getSpaceClasses(x, y)"
                       [rotation]="getPieceRotation()"
                       [secondaryContent]="getHouseSecondaryContent(x, y)"></g>
                </g>
            }
        </g>
    }
    <line id="horizontal-line"
          x1="120"
          [attr.y1]="getVerticalCenter()"
          [attr.x2]="viewBoxWidth() - 120"
          [attr.y2]="getVerticalCenter()"
          class="base"/>
    <line x1="120"
          y1="0"
          x2="120"
          [attr.y2]="getViewBoxHeight()"
          class="base"/>
    <line [attr.x1]="viewBoxWidth() - 120"
          y1="0"
          [attr.x2]="viewBoxWidth() - 120"
          [attr.y2]="getViewBoxHeight()"
          class="base"/>

    <g id="store-PLAYER_ZERO"
       (click)="onStoreClick(Player.ZERO)"
       app-numbered-circle
       [attr.transform]="getStoreTranslate(Player.ZERO)"
       [x]="-1"
       [y]="-1"
       [content]="getStoreContent(Player.ZERO)"
       [spaceClasses]="getSpaceClasses(-1, -1)"
       [rotation]="getPieceRotation()"
       [secondaryContent]="getStoreSecondaryContent(Player.ZERO)"></g>
    <g id="store-PLAYER_ONE"
       (click)="onStoreClick(Player.ONE)"
       app-numbered-circle
       [attr.transform]="getStoreTranslate(Player.ONE)"
       [x]="-1"
       [y]="1"
       [content]="getStoreContent(Player.ONE)"
       [spaceClasses]="getSpaceClasses(-1, 1)"
       [rotation]="getPieceRotation()"
       [secondaryContent]="getStoreSecondaryContent(Player.ONE)"></g>
</svg>
